import React from 'react';
import { Text } from '@/components/ui/typography';
import { cn } from '@/lib/utils';

function ScoreMetric({ name, score, percentage, color }) {
  return (
    <div className="mt-2.5 first:mt-0">
      <Text className="text-foreground font-medium text-sm mb-2">{name}</Text>
      <div className="relative h-[18px]">
        <div className="bg-[#CAE6F5] rounded-md h-full w-full">
          <div 
            className="h-[17px] rounded-md transition-all duration-300"
            style={{
              width: `${percentage}%`,
              backgroundColor: color
            }}
          />
        </div>
        <div className="absolute right-[119px] bottom-0 text-foreground font-medium text-xs">{ score !== "null/10" ? score : "N/A"}</div>
      </div>
    </div>
  );
}

export default ScoreMetric;